import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import StatusesTable from './StatusesTable';
import { EditKeysType } from './constants';
import { SkladonMappingType } from '../../types/skladonMapping';
import ShippingMethodsTable, { ShippingMethodsEditKeysType, ShippingMethodsType } from './ShippingMethodsTable';
import { UserServiceCode } from '../../types/user';
import PaymentMethodsTable, { MappingPaymentsEditKeysType, MappingPaymentType } from './PaymentMethodsTable';
import OthersTable, { OthersEditKeysType } from './OthersTable';

export interface RenderComponentsPropsType {
    statusesData?: SkladonMappingType[] | null;
    shippingMethodsData?: ShippingMethodsType[] | null;
    boolNumberCodes: ConstantsCodeType[];
    orderStatuses: ConstantsCodeType[];
    shipperCodes: ConstantsCodeType[];
    shipperServiceCodes: ConstantsCodeType[];
    paymentMethodCodes: ConstantsCodeType[];
    paymentMethodsData?: MappingPaymentType[] | null;
    productTypeData?: SkladonMappingType | null;
    orderTypeData?: SkladonMappingType[] | null;
    retinoData?: SkladonMappingType[] | null;
    providerServiceCodes: UserServiceCode[];
    activeTab: string;
    changeStatusesValue: (key: EditKeysType, value: any, error: boolean, id: number) => void;
    changeShippingMethodsValue: (key: ShippingMethodsEditKeysType, value: any, error: boolean, id: number) => void;
    changePaymentMethodsValue: (key: MappingPaymentsEditKeysType, value: any, error: boolean, id: number) => void;
    changeProductTypeValue: (value: string) => void;
    changeOrderTypeValue: (key: OthersEditKeysType, value: any, error: boolean, id: number) => void;
    changeRetinoValue: (key: OthersEditKeysType, value: any, error: boolean, id: number) => void;
    addOrderType: () => void;
    removeOrderType: (id: number) => void;
    addRetinoMapping: () => void;
    removeRetinoMapping: (id: number) => void;
    hasRetinoConfig?: boolean;
    statusesLoading: boolean;
    shippingMethodsLoading: boolean;
    paymentMethodsLoading: boolean;
    othersLoading: boolean;
    changePaymentMethodValues: (changes: { key: MappingPaymentsEditKeysType, value: any, error: boolean }[], id: number) => void;
    changeStatusesValues: (changes: { key: EditKeysType, value: any, error: boolean }[], id: number) => void;
    providerSystem?: string;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {

    const renderStatuses = () => (
        <FormBlock>
            <StatusesTable
                boolNumberCodes={props.boolNumberCodes}
                orderStatuses={props.orderStatuses}
                changeValue={props.changeStatusesValue}
                changeValues={props.changeStatusesValues}
                data={props.statusesData}
                loading={props.statusesLoading}
            />
        </FormBlock>
    );

    const renderShippingMethods = () => (
        <FormBlock>
            <ShippingMethodsTable
                boolNumberCodes={props.boolNumberCodes}
                changeValue={props.changeShippingMethodsValue}
                data={props.shippingMethodsData}
                providerServiceCodes={props.providerServiceCodes}
                shipperCodes={props.shipperCodes}
                shipperServiceCodes={props.shipperServiceCodes}
                loading={props.shippingMethodsLoading}
            />
        </FormBlock>
    );

    const renderPaymentMethods = () => (
        <FormBlock>
           <PaymentMethodsTable
                boolNumberCodes={props.boolNumberCodes}
                changeValue={props.changePaymentMethodsValue}
                data={props.paymentMethodsData}
                paymentMethodCodes={props.paymentMethodCodes}
                changeValues={props.changePaymentMethodValues}
                loading={props.paymentMethodsLoading}
            />
        </FormBlock>
    );

    const renderOthers = () => {
        // Připravíme základní props pro OthersTable
        const othersTableProps = {
            boolNumberCodes: props.boolNumberCodes,
            productTypeData: props.productTypeData,
            orderTypeData: props.orderTypeData,
            changeProductTypeValue: props.changeProductTypeValue,
            changeOrderTypeValue: props.changeOrderTypeValue,
            addOrderType: props.addOrderType,
            removeOrderType: props.removeOrderType,
            loading: props.othersLoading,
            hasRetinoConfig: props.hasRetinoConfig,
            providerSystem: props.providerSystem
        };

        // Pokud má provider konfiguraci pro Retino, přidáme příslušné props
        if (props.hasRetinoConfig) {
            return (
                <FormBlock>
                    <OthersTable
                        {...othersTableProps}
                        retinoData={props.retinoData}
                        changeRetinoValue={props.changeRetinoValue}
                        addRetinoMapping={props.addRetinoMapping}
                        removeRetinoMapping={props.removeRetinoMapping}
                    />
                </FormBlock>
            );
        }

        // Jinak vrátíme komponentu bez Retino props
        return (
            <FormBlock>
                <OthersTable
                    {...othersTableProps}
                />
            </FormBlock>
        );
    };

    const getActiveTab = () => {
        switch (props.activeTab) {
            case 'statuses':
                return renderStatuses();
            case 'shippingMethods':
                return renderShippingMethods();
            case 'paymentMethods':
                return renderPaymentMethods();
            case 'others':
                return renderOthers();
            default:
                return null;
        }
    };

    return getActiveTab();
};

export default RenderComponents;
